import React, { useMemo } from 'react';
import './GlowingDots.scss';

const GlowingDots = ({ 
  lines = 7, 
  brightProbability = 0.15, 
  mediumProbability = 0.25 
}) => {
  const cols = 20;

  const generateRandomPattern = () => {
    const pattern = [];
    for (let i = 0; i < lines; i++) {
      const row = [];
      for (let j = 0; j < cols; j++) {
        const random = Math.random();
        if (random < brightProbability) {
          row.push(2);
        } else if (random < brightProbability + mediumProbability) {
          row.push(1);
        } else {
          row.push(0);
        }
      }
      pattern.push(row);
    }
    return pattern;
  };

  const dotPattern = useMemo(() => generateRandomPattern(), [lines]);

  const getOpacity = (value) => {
    switch(value) {
      case 1: return 0.2;
      case 2: return 1;
      default: return 0.05;
    }
  };

  return (
    <div className="dot-container" style={{ gridTemplateRows: `repeat(${lines}, 12px)` }}>
      {dotPattern.flat().map((dot, index) => 
        dot === 2 ? (
          <div key={index} className="dot glowing-dot" />
        ) : (
          <div key={index} className="dot" style={{ opacity: getOpacity(dot) }} />
        )
      )}
    </div>
  );
};

export default GlowingDots;
